<template>
  <div>
  <div class="login">
    <Row>
      <Col span="17">
      </Col>
      <Col span="5">
      <div class="verify-box">
        <Tabs value="name1" size="small" @on-click="changeTab">
          <TabPane label="账号密码登录" name="name1">
            <Form ref="usernameLoginForm" :model="form" :rules="rules" class="form">
              <Input class="username-input" id="username" v-model="form.username" size="large" clearable
                placeholder="账号/邮箱/手机号" autocomplete="off" />
              <div class="phone-erro">{{ phoneErroInfo }}</div>
              <Input class="password-input" id="password" type="password" v-model="form.password" size="large" password
                placeholder="请输入密码" autocomplete="off" />
              <div class="phone-erro">{{ passwordErro }}</div>
            </Form>
            <Button class="login-btn" type="primary" size="large" :loading="loading" @click="submitLogin" long>
              <span v-if="!loading">{{ $t("login") }}</span>
              <span v-else>{{ $t("logining") }}</span>
            </Button>
            <p class="contract">
              登录即同意
              <a href="#">《用户协议》</a>
              和
              <a href="#">《隐私政策》</a>
            </p>
          </TabPane>
          <TabPane :label="'\xa0' + '\xa0' + '验证码登录'" name="name2">
            <Form ref="mobileLoginForm" :model="form" :rules="rules" class="form">
              <Input class="username-input" id="phone" v-model="form.mobile" size="large" maxlength="11" clearable
                placeholder="手机号" autocomplete="off" />
              <div class="phone-erro">{{ phoneErro }}</div>
              <Row :gutter="16">
                <Col span="16">
                <Input class="code-input" id="code" v-model="form.code" size="large" maxlength="6" clearable
                  placeholder="请输入6位验证码" autocomplete="off" />
                </Col>
                <Col span="8">
                <Button type="primary" class="send-code" @click="sendSmsCode" :loading="sending">{{ getSms }}</Button>
                </Col>
              </Row>
            </Form>
            <div class="phone-erro">{{ codeErro }}</div>
            <Button class="login-btn" type="primary" size="large" :loading="loading" @click="submitLogin" long>
              <span v-if="!loading">{{ $t("login") }}</span>
              <span v-else>{{ $t("logining") }}</span>
            </Button>
            <p class="contract">
              登录即同意
              <a href="#">《用户协议》</a>
              和
              <a href="#">《隐私政策》</a>
            </p>
          </TabPane>
        </Tabs>
      </div>
      </Col>
      <Col span="2">
      </Col>
    </Row>

  </div>
    <div class="record-link"><a href="https://beian.miit.gov.cn" target="_blank">粤ICP备2023150359号</a></div>
  </div>
</template>

<script>
import {
  login,
  getMyOrgId,
  userInfo,
  githubLogin,
  qqLogin,
  weiboLogin,
  wechatLogin,
  dingdingLogin,
  workwechatLogin,
  getJWT,
  sendLoginSms,
  smsLogin,
  initCaptcha,
  drawCodeImage,
  getOtherSet,
  getNotice,
  getAllThemeSetting,
  testAliyunMessage,
  sendMessageCodeyuanyou,
  checkMessageCodeyuanyou
} from "@/api/index";
import { validateMobile } from "@/libs/validate";
import Cookies from "js-cookie";
import Header from "@/views/main-components/header";
import Footer from "@/views/main-components/footer";
import LangSwitch from "@/views/main-components/lang-switch";
// import RectLoading from "@/views/my-components/jmbase/rect-loading";
// import CountDownButton from "@/views/my-components/jmbase/count-down-button";
import util from "@/libs/util.js";

let RectLoading = window.jinmabasecomponents.components.RectLoading;
let CountDownButton = window.jinmabasecomponents.components.CountDownButton;
export default {
  components: {
    CountDownButton,
    RectLoading,
    LangSwitch,
    Header,
    Footer,
  },
  data() {
    return {

      firstPath: "/home",
      showMore: false,
      captchaId: "",
      captchaImg: "",
      loadingCaptcha: true,
      socialLogining: true,
      error: false,
      tabName: "username",
      saveLogin: true,
      getThemeInfoOver: null,
      getSms: "获取验证码",
      loading: false,
      sending: false,
      errorCode: "",
      phoneErroInfo: "",
      passwordErro: "",
      phoneErro: "",
      codeErro: "",
      form: {
        username: "",
        password: "",
        mobile: "",
        code: "",
      },
      rules: {
        username: [
          {
            required: true,
            message: "账号不能为空",
            trigger: "change",
          },
        ],
        password: [
          {
            required: true,
            message: "密码不能为空",
            trigger: "change",
          },
        ],
        imgCode: [
          {
            required: true,
            message: "验证码不能为空",
            trigger: "change",
          },
        ],
        mobile: [
          {
            required: true,
            message: "手机号不能为空",
            trigger: "change",
          },
          {
            validator: validateMobile,
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    getCaptchaImg() {
      this.loadingCaptcha = true;
      initCaptcha().then((res) => {
        this.loadingCaptcha = false;
        if (res.success) {
          this.captchaId = res.result;
          this.captchaImg = drawCodeImage + this.captchaId;
        }
      });
    },
    sendSmsCode() {
      if (this.form.mobile.length > 10) {
        this.phoneErro = "";
        const element = document.getElementById("phone");
        element.setAttribute(
          "style",
          "border: 0px solid red;border-radius:5px"
        );
        this.$refs.mobileLoginForm.validate((valid) => {
          if (valid) {
            this.sending = true;
            this.getSms = "发送中";
            let params = {
              phone: this.form.mobile,
              code: '1111',
              type: 'edit-pass-aliyun-msg-args',
              isLogin: true
            }
            sendMessageCodeyuanyou(params).then((res) => {
              this.getSms = "获取验证码";
              this.sending = false;
              if (res.success) {
                this.$Message.success("发送短信验证码成功");
                // 开始倒计时
                // this.$refs.countDown.startCountDown();
              } else {
                if (res.code == -1) {
                  this.$Message.warning(res.message);
                } else {
                  this.$Message.warning("发送短信验证码失败");
                }
              }
            });
          }
        });
      } else {
        this.phoneErro = "该手机号错误";
        const element = document.getElementById("phone");
        element.setAttribute(
          "style",
          "border: 1px solid red;border-radius:5px"
        );
      }
    },
    // enterHome() {
    //   // window.location.reload();
    //   console.log("enter home ", this.$router);
    //   this.$router.push({
    //     name: "home_index",
    //   });
    // },
    enterHome() {
      if (!this.getThemeInfoOver) {
        return false;
      } else {
        this.$router.push({
          path: this.firstPath,
        });
      }
    },
    getThemeInfo() {
      return new Promise((resolve, reject) => {
        getAllThemeSetting().then((res) => {
          if (res.success) {
            if (res.result.length > 0) {
              resolve(res.result[0]);
              var form = res.result[0];
              // 更新信息
              this.$store.commit("setNavTheme", form.topSetting);
              this.$store.commit("setMenuTheme", form.leftSetting);
              this.$store.commit("setLogoUrl", form.logoUrl);
              this.$store.commit("setShowTags", form.showTags);
              this.$store.commit("setFirstUrl", form.firstUrl);
              this.firstPath = form.firstUrl;
              this.$store.commit("saveTheme");
              localStorage.theme = JSON.stringify(
                this.$store.state.theme.theme
              );
            } else {
              reject(res.message);
              localStorage.removeItem("theme");
            }
          }
        });
      }).catch((err) => {
        console.log(err);
        return err;
      });
    },
    async afterLogin(res) {
      let accessToken = res.result;
      this.setStore("accessToken", accessToken);
      this.getThemeInfoOver = await this.getThemeInfo();
      getOtherSet().then((res) => {
        if (res.result) {
          let domain = res.result.ssoDomain;
          Cookies.set("accessToken", accessToken, {
            domain: domain,
            expires: 7,
          });
        }
      });
      // 获取用户信息
      userInfo().then((res) => {
        if (res.success) {
          // 避免超过大小限制
          delete res.result.permissions;
          let roles = [];
          res.result.roles.forEach((e) => {
            roles.push(e.name);
          });
          delete res.result.roles;
          this.setStore("roles", roles);
          this.setStore("saveLogin", this.saveLogin);
          if (this.saveLogin) {
            // 保存7天
            Cookies.set("userInfo", JSON.stringify(res.result), {
              expires: 7,
            });
          } else {
            Cookies.set("userInfo", JSON.stringify(res.result));
          }
          this.setStore("userInfo", res.result);
          this.$store.commit("setUserInfo", res.result);
          // 加载菜单
          util.initRouter(this, this.enterHome);
        } else {
          this.loading = false;
        }
      });
    },
    submitLogin() {
      if (this.tabName == "username") {
        this.$refs.usernameLoginForm.validate((valid) => {
          if (valid) {
            this.loading = true;
            getMyOrgId({
              username: this.form.username,
              password: this.form.password,
            }).then((res) => {
              if (res.success) {
                login({
                  username: this.form.username,
                  password: this.form.password,
                  code: this.form.imgCode,
                  captchaId: this.captchaId,
                  saveLogin: this.saveLogin,
                  orgId: res.result,
                }).then((res) => {
                  if (res.success) {
                    this.afterLogin(res);
                  } else {
                    this.loading = false;
                    this.getCaptchaImg();
                    this.phoneErroInfo = "该手机号或账号错误";
                    this.passwordErro = "密码错误";
                    const element = document.getElementById("username");
                    element.setAttribute(
                      "style",
                      "border: 1px solid red;border-radius:5px"
                    );
                    const element1 = document.getElementById("password");
                    element1.setAttribute(
                      "style",
                      "border: 1px solid red;border-radius:5px"
                    );
                  }
                });
              } else {
                this.loading = false;
                this.getCaptchaImg();
                // this.phoneErroInfo = "该手机号或账号错误"
                // this.passwordErro = "密码错误"
                // const element = document.getElementById('username');
                // element.setAttribute('style', 'border: 1px solid red;border-radius:5px');
                // const element1 = document.getElementById('password');
                // element1.setAttribute('style', 'border: 1px solid red;border-radius:5px');
              }
            });
          }
        });
      } else if (this.tabName == "mobile") {
        this.$refs.mobileLoginForm.validate((valid) => {
          if (valid) {
            if (this.form.code == "") {
              this.errorCode = "验证码不能为空";
              this.$Message.warning("验证码不能为空");
              this.codeErro = "验证码不能为空";
              const element1 = document.getElementById("code");
              element1.setAttribute(
                "style",
                "border: 1px solid red;border-radius:5px"
              );
              return;
            } else {
              this.errorCode = "";
            }
            this.loading = true;
            this.form.saveLogin = this.saveLogin;
            let params = {
              phone: this.form.mobile,
              deviceType: "pc",
              code: this.form.code,
              isLogin: true
            }
            checkMessageCodeyuanyou(params).then((res) => {
              if (res.success) {
                if (res.code == 200) {
                  this.$Message.success("登录成功");
                  this.loading = false
                  res.result = res.message
                  this.afterLogin(res);
                } else {
                  this.loading = false
                  this.$Message.error(res.message);
                }
              } else {
                this.$Message.error(res.message);
                this.loading = false;
                if (res.code == 500) {
                  this.phoneErro = "该手机号错误";
                  const element = document.getElementById("phone");
                  element.setAttribute(
                    "style",
                    "border: 1px solid red;border-radius:5px"
                  );
                }
                this.codeErro = "验证码错误";
                const element1 = document.getElementById("code");
                element1.setAttribute(
                  "style",
                  "border: 1px solid red;border-radius:5px"
                );
              }
            });
          }
        });
      }
    },
    toGithubLogin() {
      this.socialLogining = true;
      githubLogin().then((res) => {
        if (res.success) {
          window.location.href = res.result;
        } else {
          this.socialLogining = false;
        }
      });
    },
    toQQLogin() {
      this.socialLogining = true;
      qqLogin().then((res) => {
        if (res.success) {
          window.location.href = res.result;
        } else {
          this.socialLogining = false;
        }
      });
    },
    toWeiboLogin() {
      this.socialLogining = true;
      weiboLogin().then((res) => {
        if (res.success) {
          window.location.href = res.result;
        } else {
          this.socialLogining = false;
        }
      });
    },
    toWeixinLogin() {
      this.socialLogining = true;
      wechatLogin().then((res) => {
        if (res.success) {
          window.location.href = res.result;
        } else {
          this.socialLogining = false;
        }
      });
    },
    toDingdingLogin() {
      this.socialLogining = true;
      dingdingLogin().then((res) => {
        if (res.success) {
          window.location.href = res.result;
        } else {
          this.socialLogining = false;
        }
      });
    },
    toWorkwechatLogin() {
      this.socialLogining = true;
      workwechatLogin().then((res) => {
        if (res.success) {
          window.location.href = res.result;
        } else {
          this.socialLogining = false;
        }
      });
    },
    relatedLogin() {
      let q = this.$route.query;
      let error = q.error;
      if (error !== "" && error !== undefined) {
        this.$Message.error(error);
      }
      let related = q.related;
      let JWTKey = q.JWTKey;
      if (related && related == "1" && JWTKey) {
        getJWT({ JWTKey: JWTKey }).then((res) => {
          if (res.success) {
            this.socialLogining = true;
            let accessToken = res.result;
            this.setStore("accessToken", accessToken);
            getOtherSet().then((res) => {
              if (res.result) {
                let domain = res.result.ssoDomain;
                Cookies.set("accessToken", accessToken, {
                  domain: domain,
                  expires: 7,
                });
              }
            });
            // 获取用户信息
            userInfo().then((res) => {
              if (res.success) {
                // 避免超过大小限制
                delete res.result.permissions;
                let roles = [];
                res.result.roles.forEach((e) => {
                  roles.push(e.name);
                });
                delete res.result.roles;
                this.setStore("roles", roles);
                // 保存7天
                Cookies.set("userInfo", JSON.stringify(res.result), {
                  expires: 7,
                });
                this.setStore("userInfo", res.result);
                this.$store.commit("setUserInfo", res.result);
                // 加载菜单
                util.initRouter(this);
                this.$router.push({
                  name: "home_index",
                });
              } else {
                this.socialLogining = false;
                this.$Message.error("获取登录用户信息失败");
              }
            });
          } else {
            this.socialLogining = false;
            this.$Message.error("使用第三方账号登录失败");
          }
        });
      } else {
        this.socialLogining = false;
      }
    },
    handleDropDown(v) {
      if (v == "test") {
        this.test();
      } else if (v == "resetByMobile") {
        this.$router.push({
          name: "reset",
        });
      } else if (v == "resetByEmail") {
        this.$router.push({
          name: "reset",
          query: {
            type: "1",
          },
        });
      }
    },
    showNotice() {
      getNotice().then((res) => {
        if (res.success) {
          if (!res.result) {
            return;
          }
          let data = res.result;
          if (
            data.open &&
            (data.title || data.content) &&
            data.position == "LOGIN"
          ) {
            this.$Notice.info({
              title: data.title,
              desc: data.content,
              duration: data.duration,
            });
          }
        }
      });
    },
    test() {
      this.$Notice.info({
        title: "测试体验账号",
        desc: "账号：test或test2<br>密码：123456",
      });
    },
    changeTab(name) {
      if (name == "name1") {
        this.tabName = "username";
      } else if (name == "name2") {
        this.tabName = "mobile";
      }
    },
  },
  mounted() {
    this.showNotice();
    this.relatedLogin();
    this.getCaptchaImg();
  },
};
</script>

<style lang="less">
// @import "./login.less";
.login {
  background-image: url("../assets/login-background.png");
  background-size: 100% 100%;
  // background-size: cover;
  // background-position: center center;
  /* 设置背景图片不重复 */
  background-repeat: no-repeat;
  /* 设置容器充满整个屏幕 */
  width: 100vw;
  // min-width: 1600px;
  // min-height: 900px;
  height: calc(100vh - 50px);

  .verify-box {
    height: 370px;
    width: 400px;
    background: rgba(255, 255, 255, 0.5);
    border: 3px solid #ffffff;
    margin-top: 300px;
    border-radius: 8px;
    padding: 20px 30px 20px 30px;
  }

  .ivu-tabs-bar {
    border-bottom: 0px solid #dcdee2;
  }

  .ivu-tabs-ink-bar-animated {
    width: 80px !important;
    margin-left: 5.8%;
  }

  .username-input {
    width: 314px;
    margin-left: 10px;
    margin-top: 10px;
  }

  .password-input {
    width: 314px;
    margin-left: 10px;
    margin-top: 5px;
  }

  .code-input {
    width: 100%;
    margin-left: 10px;
    margin-top: 5px;
  }

  .send-code {
    height: 38px;
    width: 90px;
    margin-right: 10px;
    margin-top: 6px;
    padding: 5px;
  }

  .login-btn {
    // padding: 10px;
    margin-left: 10px;
    margin-top: 5px;
    width: 314px;
  }

  .phone-erro {
    height: 20px;
    line-height: 20px;
    margin-left: 10px;
    margin-top: 5px;
    color: red;
  }

  .contract {
    margin-top: 35px;
    margin-left: 10px;
  }
}

.record-link {
  text-align: center;
  position: relative;
  top: 0px;
}
</style>
